import { Collapse } from "antd"
import { ExclamationCircleOutlined } from "@ant-design/icons"


const FormDocuSignInvalidClients = ({ invalidClients }) => {
    const createItems = () => {
        return invalidClients?.map((invalidClient, index) => {
            return {
                key: index + 1,
                label: createLabel(invalidClient),
                children: createReasons(invalidClient.invalidReasons),
            }
        })
    }

    const createLabel = (client) => {
        let firstName = client.clientFirstName ? client.clientFirstName : ""
        let lastName = client.clientLastName ? client.clientLastName : ""
        return client.clientId + (firstName && lastName ? " - " + firstName + " " + lastName : "")
    }

    const createReasons = (invalidReasons) => {
        return (
            <table>
                <tr>
                    {invalidReasons.map(invalidReason => <td><ExclamationCircleOutlined /> {invalidReason}</td>)}
                </tr>
            </table>
        )
    }


    return (
        <>
            <div className='top-header'>
                    <header>Invalid Clients</header>
                </div>
            <Collapse items={createItems()} />
        </>
    )
}

export default FormDocuSignInvalidClients